import { KeyType } from "react-relay/relay-hooks/helpers";
import { MenuOption } from "@lexical/react/LexicalTypeaheadMenuPlugin";

export type Trigger = "@";

export interface Suggestion {
  key: string;
  value?: string;
}

export type SuggestionData<TKey extends KeyType> = TKey & Suggestion;

export type GenericNode<TKey extends KeyType> =
  | { node: SuggestionData<TKey> }
  | { node: { entity: SuggestionData<TKey> } };

class BaseTypeaheadOption<TKey extends KeyType> extends MenuOption {
  node: SuggestionData<TKey>;

  constructor(node: SuggestionData<TKey>) {
    super(node.key);
    this.node = node;
  }
}

export interface MenuListItemProps {
  index: number;
  isSelected: boolean;
  onClick: () => void;
  onMouseEnter: () => void;
}

export class GenericTypeaheadOption<
  TKey extends KeyType,
> extends BaseTypeaheadOption<TKey> {
  constructor(node: SuggestionData<TKey>) {
    super(node);
  }
}

export type SuggestionPluginRenderItem<TKey extends KeyType> = (
  item: GenericTypeaheadOption<TKey>,
  props: MenuListItemProps,
) => JSX.Element;

export type Suggestions<
  TMap extends Record<string, KeyType> = Record<Trigger, KeyType>,
> = {
  [K in keyof TMap]: ReadonlyArray<GenericNode<TMap[K]>>;
};

export type PluginProps<
  TMap extends Record<string, KeyType> = Record<Trigger, KeyType>,
> = {
  onSearch: (value?: string) => Suggestions<TMap> | Promise<Suggestions<TMap>>;
  renderItems: {
    [K in keyof TMap]: SuggestionPluginRenderItem<TMap[K]>;
  };
  maxItems?: number;
  delay?: number;
};
